export { Tile, type TileProps } from "./tile";
